export enum TimelineRowVariant {
	Task = "task",
	Timeline = "timeline",
}
